import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 55.5 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><clipPath id=\"i-987243831__a\"><path fill=\"#fff\" d=\"M31.5 0h24v24h-24z\"></path></clipPath></defs><g clip-path=\"url(#i-987243831__a)\"><path d=\"M31.5 0h24v24h-24z\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"m45.5 6 6 6-6 6\"></path></g><path stroke=\"currentColor\" stroke-width=\"2\" d=\"M0 12h51\"></path>", 3)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "long-array"}) } }